import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { useHistory } from "react-router-dom";
import API from "@/api/serverCall";
import { useSnackbar } from "notistack";
import getOrganizationInfoRequestThunk from "@/redux/organization/thunk";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

interface IDeleteDialogProps {
	openModal: boolean;
	handleModalClose: () => void;
	appObjectId: number;
	appObjectName: string;
}

const DeleteDialog: React.FC<IDeleteDialogProps> = ({
	openModal,
	handleModalClose,
	appObjectId,
	appObjectName,
}) => {
	const { t } = useTranslation();
	const history = useHistory();
	const dispatch = useDispatch();
	const { enqueueSnackbar } = useSnackbar();
	const [deleteAppName, setDeleteAppName] = React.useState("");
	const deleteAppFunc = () => {
		// loading
		try {
			API.DELETE<string>({
				link: `/app/${appObjectId}`,
			}).then(() => {
				dispatch(getOrganizationInfoRequestThunk());
				handleModalClose();
				history.push(`/`);
				enqueueSnackbar(t("application_delete.success"), {
					variant: "info",
				});
			});
		} catch (error) {
			console.error(error);
		}
	};
	return (
		<Dialog onClose={handleModalClose} open={openModal} fullWidth={true}>
			<DialogTitle sx={{ fontSize: "2rem" }}>
				{t("application_delete.title")}
			</DialogTitle>
			<DialogContent>
				<div style={{ marginTop: "2rem" }}>
					<span>
						{t("application_delete.guide")}
						<span style={{ color: "#df2222" }}>{appObjectName}</span>
					</span>
					<TextField
						id="outlined-basic"
						variant="outlined"
						size="medium"
						placeholder={appObjectName}
						value={deleteAppName}
						fullWidth={true}
						sx={{ marginTop: "0.5rem" }}
						onChange={(e) => {
							setDeleteAppName(e.target.value);
						}}
					/>
				</div>
				<div
					style={{
						display: "flex",
						justifyContent: "flex-end",
						marginTop: "5rem",
					}}
				>
					<Button
						variant="outlined"
						sx={{
							color: "#747474",
							borderColor: "#CCCCCC",
							marginRight: "0.5rem",
						}}
						onClick={(e) => {
							setDeleteAppName("");
							handleModalClose();
						}}
					>
						{t("application_delete.cancel")}
					</Button>
					<Button
						variant="contained"
						sx={{ backgroundColor: "#2453F9", color: "white" }}
						onClick={deleteAppFunc}
						disabled={appObjectName !== deleteAppName}
					>
						{t("application_delete.delete")}
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
};
export default DeleteDialog;
